import React, { useEffect, useState } from 'react';

import laceScateNft from '../assets/images/connect-wallet/lace-scate-nft.png'
import wcCollectionNft from '../assets/images/connect-wallet/wc-2022-collection-nft.png'
import worldMobileNft from '../assets/images/connect-wallet/world-mobile-earth-node-nft.png'

import PageHeader from '../components/page-header';
import ErrorInformation from '../components/error-information';
import CustomCombobox from '../components/combobox';
import ButtonFilled from '../components/button-filled';
import NftRequiredComponent from '../components/nft-required-component';
import { BrowserWallet } from '@meshsdk/core';
import { useDispatch, useSelector } from 'react-redux';
import { connectLucidWallet, selectWalletAddress, setWalletAddress, setWalletAsync } from '../redux/walletSlice';
import { selectIsPublicSale } from '../redux/saleTypeSlice';
import { selectStockItemsStats } from '../redux/stockItemsStatsSlice';
import { showToastError } from '../components/toastNotification';
import { selectConfig } from '../redux/configSlice';
import WaitingLoaderHover from './modals/waiting-loader-hover';
import { BackendApi } from './router-page';

const ConnectWalletPrivatePage = ({ handleNext, fetchStockStats }) => {
  const dispatch = useDispatch();
  const [wallets, setWallets] = useState([]);
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [isOutOfStock, setIsOutOfStock] = useState(false);
  const [isStockPending, setIsStockPending] = useState(false);
  const [isNftFound, setIsNftFound] = useState(false);
  const isPublicSale = useSelector(selectIsPublicSale);
  const stockInfo = useSelector(selectStockItemsStats);
  const [walletAddress, setWalletAddress] = useState(null); 
  const config = useSelector(selectConfig);
  const finalWalletAddress = useSelector(selectWalletAddress); 

  const [isLoading, setIsLoading] = useState(false);
  const [isGoingNextStep, setIsGoingNextStep] = useState(false);

  useEffect(() => {
    setIsOutOfStock(stockInfo.inventory === 0);
    setIsStockPending(stockInfo.pending > 0);
  }, [stockInfo])

  useEffect(() => {
    setWallets(BrowserWallet.getInstalledWallets().map(wallet => wallet.name));
  }, [])

  async function checkNft(address) {
    try {
      if (!address)
      {
        setIsNftFound(false);
        return false;
      }

      const response = await BackendApi.post(
        `/script/check-nft`,
        { walletAddress: address }
      );
      setIsNftFound(response.data.success);
      return response.data.success;
    }
    catch {
      setIsNftFound(false);
      return false;
    }
  }

  async function cancelPendingOrders(address) {
    try {
      await BackendApi.post(
        `/script/cancel`,
        {
          buyer: address
        }
      );
    }
    catch {
      return;
    }
  }

  const handleSelect = async (value) => {
    try {
      setIsLoading(true);
      setIsNftFound(false);
      const wallet = await BrowserWallet.enable(value);
      await dispatch(setWalletAsync(value, config));
      if (!isPublicSale && value)
      {
        const address = await connectLucidWallet(value, config);
        setWalletAddress(address);
        await checkNft(address);
      }
      setSelectedWallet(value);
    } catch (error) {
      console.error(error);
      await dispatch(setWalletAsync(null, config));
      setSelectedWallet(null);
    } 
    finally {
      setIsLoading(false);
    }
  };

  const goToQuiz = async () => {
    try {
      setIsGoingNextStep(true);
      await cancelPendingOrders(finalWalletAddress);
      if (!isPublicSale) {
        let isNftFound = await checkNft(walletAddress);
        if (!isNftFound)
        {
          showToastError({title: 'NFT validation error', body: 'Neither of the participating NFT not detected'});
          return;
        }
      }

      await fetchStockStats();

      if (stockInfo.inventory === 0) 
        return;

      handleNext();
    }
    finally {
      setIsGoingNextStep(false);
    }
  }

  return (
    <section className='page-container'>
      <div className='order-page connect-wallet-stage'>
        <div className='center-items-horizontal'>
          <PageHeader currentStepNumber={1} />

          <div className='connect-wallet-steps'>
            <p className='connect-step'>Please follow the next step to complete your purchase(s).</p>
            <p className='connect-step'>To purchase the LVLCS x World Mobile Football Home Jersey, please do the following:</p>
            <p className='connect-step'>{isPublicSale ? 'Connect wallet and make sure you have sufficient funds.' : 'Confirm that you have one of the following in the same wallet you will mint with:'}</p>
            
            {!isPublicSale &&
              <div className='nft-required-info'>
                <NftRequiredComponent name='LVLCS LaceSkate NFT' img={laceScateNft} alt='LaceSkate NFT' />
                <NftRequiredComponent name='LVLCS WC 2022 Collection NFT' img={wcCollectionNft} alt='WC 2022 Collection NFT' />
                <NftRequiredComponent name='World Mobile Earth Node NFT' img={worldMobileNft} alt='World mobile NFT' />
              </div>
            }

            <CustomCombobox placeholder={'CHOOSE WALLET'} currentValue={selectedWallet} options={wallets} onSelect={handleSelect} isCentered={true} customStyles={{ margin: '44px 0 0 0', width: '352px' }} />

            {!isPublicSale && selectedWallet && !isNftFound && <ErrorInformation information= 'Participating NFT(s) Not detected. Please make sure the correct NFT(s) are in your wallet.'/> }   
            {isOutOfStock && !isStockPending && <ErrorInformation information= 'The current collection is already sold out.'/> }
            {isOutOfStock && isStockPending && <ErrorInformation information={<p>Now this collection's stock is empty, but you can wait a bit, as there <span>{stockInfo.pending}</span> pending</p>}/> }

          </div>
        </div>

        <div className='navigation-block-buttons'>
          <ButtonFilled label='NEXT' palette='primary' size='regular' customStyles={{width: 352}} disabled={isOutOfStock || !selectedWallet || (!isPublicSale && !isNftFound)} onClick={goToQuiz}/>
        </div>
      </div>
      <WaitingLoaderHover isOpen={isLoading || isGoingNextStep}/>
    </section>
  );
};

export default ConnectWalletPrivatePage;